import type {
  DeliveryZoneModeUpdateRequestType,
  DeliveryZoneModeUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useDeliveryZoneModeUpdate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  return useMutation({
    mutationFn: (data: DeliveryZoneModeUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: "delivery-zones/mode",
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as DeliveryZoneModeUpdateResponseType,
      ),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [user?.uid, business?.id, ServerStateKeys.Suppliers],
        }),
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.CustomerZones],
        }),
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.DeliveryArea],
        }),
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.FulfillmentType],
        }),
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.DeliveryZoneModeAssignments],
        }),
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.Relationships],
        }),
      ]);
    },
  });
};
